import React from 'react';
import style from './slide.module.scss';
export type SlideType = {
    title: string;
    text: string;
    link?: string;
    picture?: {
        url: string;
        alt: string;
        id: string;
    };
};

type SlideProps = {
    slide: SlideType;
    key: string;
};
export default function Slide({ slide, key }: SlideProps) {
    return (
        <div key={key} className={style.slideContent}>
            <div className={style.title}>{slide.title}</div>
            <div className={style.text}>{slide.text}</div>
            {slide.link && (
                <a className={style.lien} href={slide.link}>
                    en savoir plus
                </a>
            )}
            <img className={style.picture} src={slide.picture?.url} alt={slide.picture ? slide.picture.alt : ''} />
        </div>
    );
}
